// SEO metadata constants – single source of truth for page-level title/description.
// Import SEO_HOME in pages/index.jsx instead of hard-coding strings inline.

export const SEO_HOME = {
  title: 'รถมือสองเชียงใหม่ คัดเกรดพรีเมียม ฟรีดาวน์ | ครูหนึ่งรถสวย',
  description:
    'ศูนย์รวมรถมือสองเชียงใหม่ รถบ้านสภาพสวย คัดเฉพาะรถมือเดียว ฟรีดาวน์ ดอกเบี้ยพิเศษ รับประกัน 1 ปีเต็ม มีใบรับรองการตรวจสภาพ โทร 094-064-9018',
};

export const SEO_ALL_CARS = {
  title: 'รวมรถมือสองเชียงใหม่ ครบทุกค่าย อัปเดตล่าสุด ฟรีดาวน์ | ครูหนึ่งรถสวย',
  description:
    'เลือกรถมือสองเชียงใหม่จากสต็อกจริง Toyota, Honda, Isuzu, Mazda ฟรีดาวน์ 0% รับประกัน 1 ปี',
};

export const SEO_CONTACT = {
  title: 'ติดต่อเรา | ครูหนึ่งรถสวย เต็นท์รถบ้านมือสองเชียงใหม่',
  description: 'ติดต่อซื้อขายรถมือสองเชียงใหม่ โทร 094-064-9018 LINE @krunung.car',
};
